import React from "react";

function NoMatch(props) {
  return <div>No existe.</div>;
}

export default NoMatch;
